import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=684a143a&scoped=true"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a143a",
  null
  
)

export default component.exports